import React from "react";
import styled from "styled-components";
import Layout from "../components/Layout";

const Service1 = (props: any) => {
  return (
    <Layout>
      <Container>
        <Title>النقل الترددي</Title>
        <SubTitle>
          یسرنا إعلامکم بتدشین خدمة نقلٍ تردديٍ من مدینة جدة الصناعیة الأولی إلی
          کلٍ من المدینة الصناعیة الثانیة والمدینة الصناعیة الثالثة، وبالعکس.
          بالإضافة إلی ذلك، قمنا بتدشین خدمة التوزیع والتجمیع داخل المدینتین
          الصناعیتین الثانیة والثالثة.
        </SubTitle>
        <Spacer />
        <Spacer />
        <Spacer />
        <Title>نقاط التوقف الرئيسية</Title>

        <Row>
          <Card
            href="https://www.google.com.sa/maps/place/21°25%2749.4%22N+39°12%2753.8%22E/@21.4306706,39.214324,258m/data=!3m1!1e3!4m5!3m4!1s0x0:0x0!8m2!3d21.430384!4d39.214933?hl=en"
            target="_blank"
          >
            <Icon src="https://www.svgrepo.com/show/84003/pin.svg" />
            <CardTitle> نقطة التوقف الأولى (نقطة الانطلاقة)</CardTitle>{" "}
            <span>ولعرض الموقع على الخريطة انقر هنا</span>
          </Card>

          <Card
            href="https://www.google.com.sa/maps/place/21°06%2735.3%22N+39°15%2714.1%22E/@21.1098,39.2517383,784m/data=!3m2!1e3!4b1!4m5!3m4!1s0x0:0x0!8m2!3d21.1098!4d39.253927?hl=en"
            target="_blank"
          >
            <Icon src="https://www.svgrepo.com/show/84003/pin.svg" />
            <CardTitle>نقطة التوقف الثانية</CardTitle>{" "}
            <span>ولعرض الموقع على الخريطة انقر هنا</span>
          </Card>

          <Card
            href="https://www.google.com.sa/maps/place/21°06%2724.4%22N+39°19%2752.2%22E/@21.10678,39.3289713,784m/data=!3m2!1e3!4b1!4m5!3m4!1s0x0:0x0!8m2!3d21.10678!4d39.33116?hl=en"
            target="_blank"
          >
            <Icon src="https://www.svgrepo.com/show/84003/pin.svg" />
            <CardTitle>نقطة التوقف الثالثة</CardTitle>
            <span>ولعرض الموقع على الخريطة انقر هنا</span>
          </Card>
        </Row>

        <SubTitle>
          وسيكون تواجد الحافلة في كل نقطة توقف رئيسية على راس كل ساعة
        </SubTitle>
        <Spacer />
        <Spacer />
        <Spacer />
        <Title>أوقات العمل</Title>
        <Row>
          <Card>
          <Title>من الساعة 6 صباحاً</Title>
            
            
            
            </Card>
          <h1>إلى</h1>
          <Card>
          <Title>الساعة 4 مساء</Title>
            
            </Card>
        </Row> <Spacer />
        <Spacer />
        <Spacer /> <Spacer />
        <Spacer />
        <Spacer /> <Spacer />
        <Spacer />
        <Spacer />
      </Container>
    </Layout>
  );
};

const Icon = styled.img`
  width: 50px;
  height: 50px;
`;

const Spacer = styled.div`
  height: 20px;
  width: 20px;
`;
const Container = styled.div`
  padding: 20px;
  background-color: #e74f3d;
  direction: rtl;
  height: 100vh;
  overflow: auto;
  span {
    color: #818181;
  }
`;

const Title = styled.h1``;
const CardTitle = styled.h2``;

const SubTitle = styled.h3``;
const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
const Card = styled.a`
  color: #222;
  box-sizing: border-box;
  background: #fff;
  border-radius: 0.3rem;
  border: 2rem solid #fff;
  box-shadow: 0 0.1rem 0.2rem 0 rgb(0 0 0 / 7%);
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  position: relative;
  bottom: 0;
  font-size: 1em;
  font-weight: bold;
  &:hover {
    box-shadow: 0 0.25rem 0.525rem 0 rgba(0, 0, 0, 0.08);
    bottom: 2px;
  }
  @media (max-width: 768px) {
    margin: 10px;
  }
`;

export default Service1;
